import {
  ensureEmptyCookieState,
  serviceRequiresFurtherConfiguration,
  setBufferPageSourceURLCookie,
} from '../../exports/Orchestrator/channelConnections/utils'
import {
  setIsRefreshingChannelConnection,
  setShowChannelStorefront,
  setStartConnection,
  setStartConversion,
} from '../../exports/Orchestrator/store/channelConnectionsReducer'
import type { Service } from '../../exports/Orchestrator/channelConnections/types'
import type { ConnectChannelParams } from './types'

export const ORCHESTRATOR_ACTIONS = {
  connectChannel(args: ConnectChannelParams): void {
    const {
      selectedService,
      isRefreshingConnection,
      name,
      destinationUrl,
      cta,
      selectedRefreshChannelId,
      customChannelIdToConvert,
      authMethod,
      prefillDataAfterConnection = false,
      skipCelebrationModal = false,
      skipConfigurationModal = false,
      skipChannelCheck = false,
    } = args

    ensureEmptyCookieState()

    setBufferPageSourceURLCookie(window.location.href)

    const requiresFurtherConfiguration = serviceRequiresFurtherConfiguration({
      service: selectedService,
      isRefreshingConnection: !!isRefreshingConnection,
    })

    if (window?.appshell?.orchestratorStore) {
      // Converting a custom channel
      if (customChannelIdToConvert) {
        window.appshell.orchestratorStore.dispatch(
          setStartConversion({
            selectedService,
            customChannelIdToConvert,
            cta,
            authMethod,
          }),
        )
        return
      }

      // Normal channel connection
      window.appshell.orchestratorStore.dispatch(
        setStartConnection({
          selectedService,
          destinationUrl,
          cta,
          authMethod,
          serviceRequiresFurtherConfiguration:
            !skipConfigurationModal && requiresFurtherConfiguration,
          prefillDataAfterConnection,
          skipCelebrationModal,
        }),
      )

      if (isRefreshingConnection) {
        window.appshell.orchestratorStore.dispatch(
          setIsRefreshingChannelConnection({
            selectedService,
            selectedRefreshChannelId,
            name,
            authMethod,
            skipChannelCheck,
          }),
        )
      }
    }
  },
  openChannelStorefront({
    cta,
    prefillDataAfterConnection = false,
    skipCelebrationModal = false,
    selectedService,
    isSettingPostingGoal = false,
  }: {
    cta: string
    prefillDataAfterConnection?: boolean
    skipCelebrationModal?: boolean
    selectedService?: Service
    isSettingPostingGoal?: boolean
  }): void {
    window?.appshell?.orchestratorStore.dispatch(
      setShowChannelStorefront({
        cta,
        prefillDataAfterConnection,
        skipCelebrationModal,
        selectedService,
        isSettingPostingGoal,
      }),
    )
  },
}

export type ORCHESTRATOR_ACTIONS_TYPE = typeof ORCHESTRATOR_ACTIONS
